<template>
  <div
    :class="DS_TITLE_FIELD_CLASSES.Error"
    role="alert"
    data-cy="ds-title-field__error"
  >
    <div :class="DS_TITLE_FIELD_CLASSES.ErrorMessages">
      <DSFormFieldError
        v-for="(errorMessage, index) in props.errorMessages"
        :id="`${props.errorMessageIdPrefix}-${index}`"
        :key="`${props.errorMessageIdPrefix}-${index}`"
        :error-message="errorMessage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import DSFormFieldError from "@/src/design_system/form_elements/form_field_error/components/DSFormFieldError.vue";
import { DS_TITLE_FIELD_CLASSES } from "@/src/design_system/form_elements/title_field/constants/classes";
import type { DSTitleFieldErrorsProps } from "@/src/design_system/form_elements/title_field/types/internal";

const props = defineProps<DSTitleFieldErrorsProps>();
</script>
